'use strict';
import axios from "@/plugins/axios";

export const blogPost = {
    namespaced: true,
    state: {
        blogPosts: []
    },
    getters: {
        getBlogPosts: state => state.blogPosts,

    },
    mutations: {
        UPDATE_BLOG_POSTS: (state, payload) => { state.blogPosts = payload }
    },
    actions: {
        async createBlogPost({ state }, payload) {
            try {
                let res = (await axios.post('/api/blogPost', payload)).data;
                if (res.success) state.blogPosts.unshift(res.data)
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                 
                return error;
            }
        },
        async getBlogPosts({ commit }) {
            try {
                let res = (await axios.get('/api/blogPost')).data;
                 
                if (res.success) commit("UPDATE_BLOG_POSTS", res.data)
            } catch (error) {
                 
                return error;
            }
        },
        async updateBlogPost({ state }, payload) {
            try {
                let res = (await axios.put(`/api/blogPost`, payload)).data;
                 
                if (res.success) {
                    state.blogPosts.forEach((post, i) => {
                         
                         
                        if (post._id === payload._id) state.blogPosts[i] = res.data;
                    })
                }
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                return error;
            }
        },
        async blockPost({ state }, payload) {
            try {
                let res = (await axios.get(`/api/blogPost/block/${payload}`)).data;
                if (res.success) state.blogPosts.filter((post, index) => {
                    if (post._id === payload) {
                         
                        state.blogPosts[index].blocked = !state.blogPosts[index].blocked;
                        state.blogPosts[index].blocked_by = res.data.blocked_by;
                    }
                })
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                return error
            }
        },
        async deleteBlogPost({ state }, payload) {
            try {
                let res = (await axios.delete(`api/blogPost/${payload.id}`)).data;
                if (res.success) {
                    state.blogPosts.splice(state.blogPosts.findIndex(n => n._id === payload.id), 1);
                }
                window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                return error;
            }

        },
        async uploadImage(_context, payload) {
            try {
                 
                let res = (
                    await axios.post("api/blogPost/uploadImage", payload, {
                        headers: { "Content-Type": "multipart/form-data" },
                    })
                ).data;
                if (res.success) return res.data;
                else window.flash({
                    type: res.success ? "success" : "error",
                    msg: res.message,
                });
            } catch (error) {
                return error;
            }
        },
    }

}